var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectPath from './services/ProtectedPath/ProtectPath';
import { GlobalLoader, GlobalErrorModal, ToastsContainer, SuspenseLoader } from './components';
import useTheme from './hooks/useTheme';
const Login = lazy(() => import('./pages/Auth/Login/Login'));
const UpdatePassword = lazy(() => import('./pages/Auth/UpdatePassword/UpdatePassword'));
const SignUp = lazy(() => import('./pages/Auth/SignUp/SignUp'));
const Statistics = lazy(() => import('./pages/Statistics/StatsPage'));
const HeaderLayout = lazy(() => import('./layout/HeaderLayout'));
const Application = lazy(() => import('./pages/Application/Application'));
const VerifyPassword = lazy(() => import('./pages/Auth/VerifyPassword/VerifyPassword'));
const VerifyEmail = lazy(() => import('./pages/Auth/VerifyEmail/VerifyEmail'));
const Notifications = lazy(() => import('./pages/Notifications/NotificationsPage'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));
function App() {
    useTheme();
    useEffect(() => {
        const fetchPingServer = () => __awaiter(this, void 0, void 0, function* () {
            yield fetch('https://taskmaster-backend-e940.onrender.com/ping');
        });
        fetchPingServer();
    }, []);
    useEffect(() => {
        const setAppHeight = () => {
            const viewHeight = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--app-height', `${viewHeight * 100}px`);
        };
        setAppHeight();
        window.addEventListener('resize', setAppHeight);
        return () => window.removeEventListener('resize', setAppHeight);
    }, []);
    return (_jsx(Suspense, Object.assign({ fallback: _jsx(SuspenseLoader, {}) }, { children: _jsxs(Router, { children: [_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Login, {}) }), _jsx(Route, { path: "/login", element: _jsx(Login, {}) }), _jsx(Route, { path: "/sign-up", element: _jsx(SignUp, {}) }), _jsx(Route, { path: "/update-password", element: _jsx(UpdatePassword, {}) }), _jsx(Route, { path: "/verify-password", element: _jsx(VerifyPassword, {}) }), _jsx(Route, { path: "/verify-email", element: _jsx(VerifyEmail, {}) }), _jsx(Route, Object.assign({ element: _jsx(ProtectPath, {}) }, { children: _jsxs(Route, Object.assign({ element: _jsx(HeaderLayout, {}) }, { children: [_jsx(Route, { path: "/statistics", element: _jsx(Statistics, {}) }), _jsx(Route, { path: "/application", element: _jsx(Application, {}) }), _jsx(Route, { path: "/notifications", element: _jsx(Notifications, {}) })] })) })), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] }), _jsx(GlobalErrorModal, {}), _jsx(ToastsContainer, {}), _jsx(GlobalLoader, {})] }) })));
}
export default App;
